export { default as userHelper } from './helper';
import { module, Mutations } from '@/store/modules/user/helper';

export default {
    namespaced: true,
    state: {
        bank: undefined,
        bankSearch: undefined,
        info: {},
        static: {},
        validisConfig: {},
        acceptedTerms: false,
        acceptedPrivacy: false,
        externalReference: null,
        referenceGuid: null,
        collections: {
            jointDebt: null,
            adult: null,
            sixteenToEighteen: null,
            underSixteen: null,
            numberOfVehicles: null,
            priorityArrears: {
                mortgage: false,
                rent: false,
                serviceCharge: false,
                sharedOwnership: false,
                gas: false,
                water: false,
                electricity: false,
                councilTax: false,
                childMaintenance: false,
                hirePurchase: false,
                hmrc: false,
            },
            paymentInPlace: null,
            wouldLikeHelp: null
        },
        scenarioMessage: {},
        collectionsEmployment: {
            employmentStatus: null,
            incomeReduced: null,
            incomeReducedValue: null,
            incomeReducedExtended: null,
            incomeTimingIssue: null,
            governmentSupportApplication: null,
            governmentSupportApplicationSuccessful: null,
            governmentSupportReceived: null,
            governmentSupportExpectedDate: null,
            governmentSupportDecision: null,
            meetContractualPayments: null,
            sensitiveInformation: null,
            expectedChangeInEmployment: null,
            receiveRedunancyPayment: null,
            receiptOfBenefits: null,
            appliedForBenefits: null,
            benefitsExpectedDate: null
        },
        collectionsBau: {
            residentialStatus: null,
            employmentStatus: null,
            financialSituationBereavement: null,
            financialSituationHealthIllness: null,
            financialSituationUnemployment: null,
            financialSituationIncomeChange: null,
            financialSituationRelationshipBreakdown: null,
            financialSituationBudgetingIssues: null,
            financialSituationUnexpectedExpense: null,
            financialSituationOther: null,
            financialDifficultyReasons: null,
            employmentDriver: null,
            employmentTerm: null,
            paymentDeferral:null,
            tailoredRepayment:null,
            terminateEarly:null,
            terminationOptions:null,
            keepVehicle:null
        },
        collectionsBauPriority: {
            priorityArrears: {
                mortgage: false,
                rent: false,
                serviceCharge: false,
                sharedOwnership: false,
                gas: false,
                water: false,
                electricity: false,
                councilTax: false,
                childMaintenance: false,
                hirePurchase: false,
                hmrc: false
            },
            paymentInPlace: null,  
            otherCreditors: null,
            otherCreditorsPaymentPlan: null,
            stepChangePriority: null,
            stepChangeOther: null,   
            jointDebt: null,
            adult: null,
            sixteenToEighteen: null,
            underSixteen: null,
            numberOfVehicles: null
        },
        collectionsBus: {
            jointDebt: null,
            adult: null,
            sixteenToEighteen: null,
            underSixteen: null,
            numberOfVehicles: null,
            priorityArrears: {
                mortgage: false,
                rent: false,
                serviceCharge: false,
                sharedOwnership: false,
                gas: false,
                water: false,
                electricity: false,
                councilTax: false,
                childMaintenance: false,
                hirePurchase: false,
                hmrc: false,
                keySuppliers: false,
                wages: false,
                securedLoans: false,
                securedBusinessLoans: false
            },
            paymentInPlace: null
        },
        collectionsBusEmployment: {
            employmentStatus: null,
            incomeReduced: null,
            incomeReducedValue: null,
            incomeReducedExtended: null,
            incomeTimingIssue: null,
            governmentSupportApplication: null,
            governmentSupportApplicationSuccessful: null,
            governmentSupportReceived: null,
            governmentSupportExpectedDate: null,
            governmentSupportDecision: null,
            meetContractualPayments: null,
            expectedChangeInEmployment: null,
            receiveRedunancyPayment: null,
            receiptOfBenefits: null,
            appliedForBenefits: null,
            benefitsExpectedDate: null
        },
        collectionsBusRFD:{
            timeElapsedRFD: null,
            circumstanceChange3Month: null,
            difficultyReasons:{
                notInDifficulty: null,  
                reducedTurnover: null,  
                supplyChainIssues: null,  
                failureKeyCustomer: null,  
                increasedRawMaterialCost: null,  
                increasedPremisesCosts: null,  
                staffingIssues: null,  
                financeBurden: null,  
                brexit: null,  
                taxBill: null,  
                creasedTrading: null,  
                bereavement: null,  
                separation: null,  
                fraud: null,  
                medicalReason: null,  
                outOfCountry: null,  
                overextended: null,  
                unexpectedExpenditure: null,  
                costOfLiving: null,  
                oneOffExpense: null,  
                pregnancy: null,  
                caringForFamilyFriends: null,  
                takenDebtSomeoneElse: null,  
                lackControlFinances: null,  
                addiction: null,  
                retirement: null, 
            }
        },
        householdComposition: {
            householdType: null,
            zeroToOne: null,
            twoToFour: null,
            primary: null,
            secondary: null,
            adult: null,
            pensioner: null
        },
        financialCircumstances: {
            residentialStatus: null,
            employmentStatus: null
        },
        income: {
            incomeType: null,
            declaredIncome: null,
            otherIncome: null
        },
        monthlyExpenditure: {
            loanRepayment: null,
            oustandingBalance: null,
            rentOrMortgage: null,
            utilities: null,
            councilTax: null,
            childcare: null,
            travel: null,
            housekeeping: null,
            other: null
        }
    },
    getters: {
        bank: (s) => s.bank,
        bankSearch: (s) => s.bankSearch,
        info: (s) => s.info,
        validisConfig: (s) => s.validisConfig,
        acceptedTerms: (s) => s.acceptedTerms,
        acceptedPrivacy: (s) => s.acceptedPrivacy,
        externalReference: (s) => s.externalReference,
        referenceGuid: (s) => s.referenceGuid,
        scenarioMessage: (s) => s.scenarioMessage
    },
    actions: {
        init({ commit }, payload) {
            commit(Mutations.ASSIGN_STATIC, payload.static);
            if (payload.bank) {
                commit(Mutations.SET_BANK, payload.bank);
            }
            if (payload.bankSearch) {
                commit(Mutations.SET_BANK_SEARCH, payload.bankSearch);
            }
            const { acceptedPrivacy, acceptedTerms } = payload;
            commit(Mutations.UPDATE_PRIVACY_TERMS, {
                acceptedTerms,
                acceptedPrivacy,
            });
            if (payload.externalReference) {
                commit(Mutations.SET_EXTERNAL_REFERENCE, payload.externalReference);
            }
            if (payload.referenceGuid) {
                commit(Mutations.SET_REFERENCE_GUID, payload.referenceGuid);
            }
        },
        isStatic({ state }, name) {
            return !!(state.static as any)[name];
        },
        updateInfo({ state, commit }, info) {
            commit(Mutations.UPDATE_INFO, info);
        },
        setValidisConfig({ state, commit }, validisConfig) {
            commit(Mutations.SET_VALIDIS_CONFIG, validisConfig);
        },
        clearBank({ commit }) {
            commit(Mutations.SET_BANK, null);
            commit(Mutations.SET_BANK_SEARCH, '');
        },
        updateCollections({ commit }, payload) {
            commit(Mutations.UPDATE_COLLECTIONS, payload);
        },
        setScenarioMessage({ state, commit }, scenarioMessage) {
            commit(Mutations.SET_SCENARIO_MESSAGE, scenarioMessage);
        },
        updateCollectionsEmployment({ commit }, payload) {
            commit(Mutations.UPDATE_COLLECTIONS_EMPLOYMENT, payload);
        },
        updateCollectionsBau({ commit }, payload) {
            commit(Mutations.UPDATE_COLLECTIONS_BAU, payload);
        },
        updateCollectionsBauPriority({ commit }, payload) {
            commit(Mutations.UPDATE_COLLECTIONS_BAU_PRIORITY, payload);
        },
        updateCollectionsBus({ commit }, payload) {
            commit(Mutations.UPDATE_COLLECTIONS_BUS, payload);
        },
        updateCollectionsBusEmployment({ commit }, payload) {
            commit(Mutations.UPDATE_COLLECTIONS_BUS_EMPLOYMENT, payload);
        },
        updateCollectionsBusRFD({ commit }, payload) {
            commit(Mutations.UPDATE_COLLECTIONS_BUS_RFD, payload);
        },
        updateHouseholdComposition({ commit }, payload){
            commit(Mutations.UPDATE_HOUSEHOLD_COMPOSITION, payload);
        },
        updateFinancialCircumstances({ commit }, payload) {
            commit(Mutations.UPDATE_FINANCIAL_CIRCUMSTANCES, payload);
        },
        updateIncome({ commit }, payload) {
            commit(Mutations.UPDATE_INCOME, payload);
        },
        updateMonthlyExpenditure({ commit }, payload){
            commit(Mutations.UPDATE_MONTHLY_EXPENDITURE, payload);
        }
    },
    mutations: {
        [Mutations.ASSIGN_STATIC](state, payload) {
            state.static = payload;
        },
        [Mutations.SET_BANK](state, bank) {
            state.bank = bank;
        },
        [Mutations.SET_BANK_SEARCH](state, search) {
            state.bankSearch = search;
        },
        [Mutations.UPDATE_INFO](state, info) {
            state.info = { ...state.info, ...info };
        },
        [Mutations.SET_VALIDIS_CONFIG](state, validisConfig) {
            state.validisConfig = { ...state.validisConfig, ...validisConfig };
        },
        [Mutations.UPDATE_PRIVACY_TERMS](state, payload) {
            state.acceptedTerms = payload.acceptedTerms;
            state.acceptedPrivacy = payload.acceptedPrivacy;
        },
        [Mutations.SET_EXTERNAL_REFERENCE](state, externalReference) {
            state.externalReference = externalReference;
        },
        [Mutations.SET_REFERENCE_GUID](state, referenceGuid) {
            state.referenceGuid = referenceGuid;
        },
        [Mutations.UPDATE_COLLECTIONS](state, payload) {
            state.collections.jointDebt = payload.jointDebt;
            state.collections.adult = payload.adult;
            state.collections.underSixteen = payload.underSixteen;
            state.collections.sixteenToEighteen = payload.sixteenToEighteen;
            state.collections.numberOfVehicles = payload.numberOfVehicles;
            state.collections.priorityArrears = payload.priorityArrears;
            state.collections.paymentInPlace = payload.paymentInPlace;
            state.collections.wouldLikeHelp = payload.wouldLikeHelp;
        },
        [Mutations.SET_SCENARIO_MESSAGE](state, scenarioMessage) {
            state.scenarioMessage = { ...state.scenarioMessage, ...scenarioMessage };
        },
        [Mutations.UPDATE_COLLECTIONS_EMPLOYMENT](state, payload) {
            state.collectionsEmployment.employmentStatus = payload.employmentStatus;
            state.collectionsEmployment.incomeReduced = payload.incomeReduced;
            state.collectionsEmployment.incomeReducedValue = payload.incomeReducedValue;
            state.collectionsEmployment.incomeReducedExtended = payload.incomeReducedExtended;
            state.collectionsEmployment.incomeTimingIssue = payload.incomeTimingIssue;
            state.collectionsEmployment.governmentSupportApplication = payload.governmentSupportApplication;
            state.collectionsEmployment.governmentSupportApplicationSuccessful = payload.governmentSupportApplicationSuccessful;
            state.collectionsEmployment.governmentSupportReceived = payload.governmentSupportReceived;
            state.collectionsEmployment.governmentSupportExpectedDate = payload.governmentSupportExpectedDate;
            state.collectionsEmployment.governmentSupportDecision = payload.governmentSupportDecision;
            state.collectionsEmployment.sensitiveInformation = payload.sensitiveInformation;
            state.collectionsEmployment.expectedChangeInEmployment = payload.expectedChangeInEmployment;
            state.collectionsEmployment.receiveRedunancyPayment = payload.receiveRedunancyPayment;
            state.collectionsEmployment.receiptOfBenefits = payload.receiptOfBenefits;
            state.collectionsEmployment.appliedForBenefits = payload.appliedForBenefits;
            state.collectionsEmployment.benefitsExpectedDate = payload.benefitsExpectedDate;        
        },
        [Mutations.UPDATE_COLLECTIONS_BAU](state, payload) {
            state.collectionsBau.residentialStatus = payload.residentialStatus;
            state.collectionsBau.employmentStatus = payload.employmentStatus;
            state.collectionsBau.employmentDriver = payload.employmentDriver;
            state.collectionsBau.employmentTerm =payload.employmentTerm;
            state.collectionsBau.financialSituationBereavement = payload.financialSituationBereavement;
            state.collectionsBau.financialSituationHealthIllness = payload.financialSituationHealthIllness;
            state.collectionsBau.financialSituationUnemployment = payload.financialSituationUnemployment;
            state.collectionsBau.financialSituationIncomeChange = payload.financialSituationIncomeChange;
            state.collectionsBau.financialSituationRelationshipBreakdown = payload.financialSituationRelationshipBreakdown;
            state.collectionsBau.financialSituationBudgetingIssues = payload.financialSituationBudgetingIssues;
            state.collectionsBau.financialSituationUnexpectedExpense = payload.financialSituationUnexpectedExpense;
            state.collectionsBau.financialSituationOther = payload.financialSituationOther;    
            state.collectionsBau.personalFinfinancialDifficultyReasonsanceSituation = payload.financialDifficultyReasons;    
            state.collectionsBau.paymentDeferral = payload.paymentDeferral;
            state.collectionsBau.tailoredRepayment = payload.tailoredRepayment;
            state.collectionsBau.terminateEarly = payload.terminateEarly;
            state.collectionsBau.terminationOptions = payload.terminationOptions;
            state.collectionsBau.keepVehicle = payload.keepVehicle;
        },
        [Mutations.UPDATE_COLLECTIONS_BAU_PRIORITY](state, payload) {
            state.collectionsBauPriority.priorityArrears = payload.priorityArrears;
            state.collectionsBauPriority.paymentInPlace = payload.paymentInPlace;
            state.collectionsBauPriority.otherCreditors = payload.otherCreditors;
            state.collectionsBauPriority.otherCreditorsPaymentPlan = payload.otherCreditorsPaymentPlan;
            state.collectionsBauPriority.stepChangePriority = payload.stepChangePriority;
            state.collectionsBauPriority.stepChangeOther = payload.stepChangeOther;
            state.collectionsBauPriority.jointDebt = payload.jointDebt;
            state.collectionsBauPriority.adult = payload.adult;
            state.collectionsBauPriority.underSixteen = payload.underSixteen;
            state.collectionsBauPriority.sixteenToEighteen = payload.sixteenToEighteen;
            state.collectionsBauPriority.numberOfVehicles = payload.numberOfVehicles;
        },
        [Mutations.UPDATE_COLLECTIONS_BUS](state, payload) {
            state.collectionsBus.jointDebt = payload.jointDebt;
            state.collectionsBus.adult = payload.adult;
            state.collectionsBus.underSixteen = payload.underSixteen;
            state.collectionsBus.sixteenToEighteen = payload.sixteenToEighteen;
            state.collectionsBus.numberOfVehicles = payload.numberOfVehicles;
            state.collectionsBus.priorityArrears = payload.priorityArrears;
            state.collectionsBus.paymentInPlace = payload.paymentInPlace;
        },
        [Mutations.UPDATE_COLLECTIONS_BUS_EMPLOYMENT](state, payload) {  
            state.collectionsEmployment.employmentStatus = payload.employmentStatus;
            state.collectionsEmployment.incomeReduced = payload.incomeReduced;
            state.collectionsEmployment.incomeReducedValue = payload.incomeReducedValue;
            state.collectionsEmployment.incomeReducedExtended = payload.incomeReducedExtended;
            state.collectionsEmployment.incomeTimingIssue = payload.incomeTimingIssue;
            state.collectionsEmployment.governmentSupportApplication = payload.governmentSupportApplication;
            state.collectionsEmployment.governmentSupportApplicationSuccessful = payload.governmentSupportApplicationSuccessful;
            state.collectionsEmployment.governmentSupportReceived = payload.governmentSupportReceived;
            state.collectionsEmployment.governmentSupportExpectedDate = payload.governmentSupportExpectedDate;
            state.collectionsEmployment.governmentSupportDecision = payload.governmentSupportDecision;
            state.collectionsEmployment.expectedChangeInEmployment = payload.expectedChangeInEmployment;
            state.collectionsEmployment.receiveRedunancyPayment = payload.receiveRedunancyPayment;
            state.collectionsEmployment.receiptOfBenefits = payload.receiptOfBenefits;
            state.collectionsEmployment.appliedForBenefits = payload.appliedForBenefits;
            state.collectionsEmployment.benefitsExpectedDate = payload.benefitsExpectedDate;      
        },
        [Mutations.UPDATE_COLLECTIONS_BUS_RFD](state, payload) {  
            
            state.collectionsBusRFD.difficultyReasons = payload.difficultyReasons;
            state.collectionsBusRFD.timeElapsedRFD = payload.timeElapsedRFD;
            state.collectionsBusRFD.circumstanceChange3Month = payload.circumstanceChange3Month;
        },
        [Mutations.UPDATE_HOUSEHOLD_COMPOSITION](state, payload){
            state.householdComposition.householdType = payload.householdType;
            state.householdComposition.zeroToOne = payload.zeroToOne;
            state.householdComposition.twoToFour = payload.twoToFour;
            state.householdComposition.primary = payload.primary;
            state.householdComposition.secondary = payload.secondary;
            state.householdComposition.adult = payload.adult;
            state.householdComposition.pensioner = payload.pensioner;
        },
        [Mutations.UPDATE_FINANCIAL_CIRCUMSTANCES](state, payload){
            state.financialCircumstances.residentialStatus = payload.residentialStatus;
            state.financialCircumstances.employmentStatus = payload.employmentStatus;
        },
        [Mutations.UPDATE_INCOME](state, payload){
            state.income.incomeType = payload.incomeType;
            state.income.declaredIncome = payload.declaredIncome;
            state.income.otherIncome = payload.otherIncome;
        },
        [Mutations.UPDATE_MONTHLY_EXPENDITURE](state, payload){
            state.monthlyExpenditure.loanRepayment = payload.loanRepayment;
            state.monthlyExpenditure.oustandingBalance = payload.oustandingBalance;
            state.monthlyExpenditure.rentOrMortgage = payload.rentOrMortgage;
            state.monthlyExpenditure.utilities = payload.utilities;
            state.monthlyExpenditure.councilTax = payload.councilTax;
            state.monthlyExpenditure.childcare = payload.childcare;
            state.monthlyExpenditure.travel = payload.travel;
            state.monthlyExpenditure.housekeeping = payload.housekeeping;
            state.monthlyExpenditure.other = payload.other;
        }
    },
} as module;

